import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({ lines = [], className = "", lineClassName = "", baseDelay = 0.15 }) => (
  <div className={className}>
    {lines.map((line, i) => (
      <div key={i} className="overflow-hidden py-[0.06em]">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "115%" }}
          animate={{ y: "0%" }}
          transition={{ delay: baseDelay + i * 0.11, duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        >
          {line}
        </motion.span>
      </div>
    ))}
  </div>
);

export const SectionHead = ({ eyebrow, title, testId }) => (
  <Reveal>
    <p className="font-jb text-xs uppercase tracking-[0.3em] text-[#CC0A14] font-semibold mb-5">
      {eyebrow}
    </p>
    <h2
      data-testid={testId}
      className="font-syne text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-tight text-white max-w-2xl"
    >
      {title}
    </h2>
  </Reveal>
);
